import { useAuth } from "@jutro/auth";
export var useAuthNoThrow = function () {
  try {
    return useAuth();
  } catch (_unused) {
    return;
  }
};